module.exports = __webpack_public_path__ + "img/bg@3x.a47beb3e.jpg";